module.exports = "/_next/static/files/4dc338fcfb40d52972aae64fa45fe9b1.svg";